import React from 'react';

import {EmojiIcon as WebkitEmojiIcon} from '@time-webkit/all/icons/emoji';

export default class EmojiIcon extends React.PureComponent<React.HTMLAttributes<HTMLSpanElement>> {
    render() {
        return (
            <span {...this.props}>
                <WebkitEmojiIcon width={16} height={16} />
            </span>
        );
    }
}
